import { createContext, useContext, useState } from "react"

export const Context = createContext()

export const WatchgridProvider = ({ children }) => {
  const [advancedPanel, setAdvancedPanel] = useState(false)
  const [filterStrip, setFilterStrip] = useState(false)

  const [mainFilter, setMainFilter] = useState(null)

  return <Context.Provider value={{ advancedPanel, setAdvancedPanel, filterStrip, setFilterStrip, mainFilter, setMainFilter }}>{children}</Context.Provider>
}

export const useWatchgrid = () => useContext(Context)
